import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import benepayLogo from "../layout/asset/benepay-transperent.png";
import Utils from "../../../service/core/utils";
import QRCode from "qrcode";
import { baseUrl } from "../../../config/urlConfig";


export default function PaymentCountdown() {
  const { traceId, transactionId, expireAt, "*": extra } = useParams();
  const parts = extra ? extra.split("/") : [];

  const upiIntent = parts[0] || null;
  const redirectMerchant = parts[1] === "true";

  const rawExpiry = parseInt(expireAt, 10);
  const expiry = rawExpiry < 1e12 ? rawExpiry * 1000 : rawExpiry;

  const [timeLeft, setTimeLeft] = useState(() =>
    Math.max(0, expiry - Date.now())
  );
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const navigate = useNavigate();

  // Get the QR URL from location state  
  const qrUrl = Utils.decodeBase64Url(upiIntent);  

  // Generate QR code if URL is present
  useEffect(() => {
    const generateQrCode = async () => {
      if (qrUrl) {
        try {
          const qrCodeUrl = await QRCode.toDataURL(qrUrl, {
            width: 200,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          setQrCodeDataUrl(qrCodeUrl);
        } catch (error) {
          console.error('Error generating QR code:', error);
        }
      }
    };

    generateQrCode();
  }, [qrUrl]);

  useEffect(() => {
    if (!expiry) return;

    let timer;

    const tick = () => {
      const remaining = Math.max(0, expiry - Date.now());
      setTimeLeft(remaining);

      if (remaining <= 0) {
        clearInterval(timer);

        window.removeEventListener("beforeunload", handleBeforeUnload);

        if (redirectMerchant) {
          window.location.replace(`${baseUrl}/v1/getPaymentResponse/${traceId}/${transactionId}`);
        } else {
          navigate(`/status?traceId=${traceId}&paymentId=${transactionId}`);
        }

      }
    };

    tick();
    timer = setInterval(tick, 1000);

    // Warn on refresh/close/back
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    test();
    return () => {
      clearInterval(timer);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
    
  }, [expiry, traceId, transactionId, navigate]);

  const formatTime = (ms) => {
    let totalSeconds = Math.floor(ms / 1000);
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

    const test = async () => {
        const fingerprint = await Utils.getBrowserFingerprint();
        console.log("fibr", fingerprint)
    }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 to-white px-4">
      <div className="bg-white shadow-2xl rounded-3xl p-6 sm:p-8 w-full max-w-sm text-center">
        {/* Logo */}
        <div className="flex justify-center mb-4 animate-fadeIn">
          <img src={benepayLogo} alt="BenePay" className="h-10 w-auto opacity-90" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-indigo-700 mb-1">
          Awaiting Your Payment
        </h1>
        {!qrCodeDataUrl && (
          <p className="text-gray-600 mb-6 text-sm leading-relaxed">
            Please open your UPI app and approve the payment request we sent.
          </p>
        )}

      {/* Minimal Spinner Loader */}
      {!qrCodeDataUrl && (
        <div className="flex justify-center mb-6">
          <div className="w-10 h-10 border-4 border-indigo-300 border-t-indigo-600 rounded-full animate-spin"></div>
        </div>
      )}

        {/* QR Code Section - Only show if QR URL is present */}
        {qrCodeDataUrl && (
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-3">Scan this QR code with any UPI app</p>
            <div className="flex justify-center">
              <img 
                src={qrCodeDataUrl} 
                alt="UPI Payment QR Code" 
                className="border-2 border-gray-200 rounded-lg shadow-md"
              />
            </div>
          </div>
        )}

        {/* Timer */}
        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-full py-3 mb-6">
          <p className="text-sm opacity-80">Time Remaining</p>
          <p className="text-3xl font-extrabold tracking-wide">
            {formatTime(timeLeft)}
          </p>
        </div>

        {/* Instructions */}
        <div className="bg-indigo-50 border border-indigo-100 rounded-xl text-left text-gray-600 text-sm space-y-3 mb-6 p-4">
          {qrCodeDataUrl ? (
            // Instructions when QR code is present
            <>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-green-500 rounded-full"></span>
                <p>Scan the QR code with your UPI app</p>
              </div>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-green-500 rounded-full"></span>
                <p>Complete the payment before the timer expires</p>
              </div>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-yellow-500 rounded-full"></span>
                <p>Do not press back or close this window</p>
              </div>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-yellow-500 rounded-full"></span>
                <p>Do not refresh this page</p>
              </div>
            </>
          ) : (
            // Default instructions when no QR code
            <>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-green-500 rounded-full"></span>
                <p>Approve the payment from your UPI app</p>
              </div>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-green-500 rounded-full"></span>
                <p>Complete the payment before the timer expires</p>
              </div>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-yellow-500 rounded-full"></span>
                <p>Do not press back or close this window</p>
              </div>
              <div className="flex items-start space-x-2">
                <span className="w-2 h-2 mt-2 bg-yellow-500 rounded-full"></span>
                <p>Do not refresh this page</p>
              </div>
            </>
          )}
        </div>

        {/* IDs */}
        <div className="text-[11px] text-gray-400 leading-relaxed">
          Transaction ID: {transactionId}
          <br />
          Trace ID: {traceId}
        </div>
      </div>
    </div>
  );
}
